import {callAPI} from '@/store/utils';

const FYGR_ACCESS_TOKEN = 'FYGR_ACCESS_TOKEN';
const FYGR_COMPANY = 'FYGR_COMPANY';
const FYGR_USER_SELECTED_PARTNER = 'FYGR_USER_SELECTED_PARTNER';
const FYGR_CURRENT_SELECTED_PARTNER = 'FYGR_CURRENT_SELECTED_PARTNER';

export default {
  namespaced: true,
  state: {
    partnerIntegrationCredentials: null,
    partnerIntegrations: [],
    partnerIntegrationVisibility: null,
    partnerManagedCompanies: [],
    selectedPartnersToSync: [],
    userRcaCredentials: {},
    userAcdCredentials: {},
    selectedPartner: null,
    partners: [],
    nextRedirectTo: 'dashboard',
  },
  mutations: {
    reset(state) {
      state.partnerManagedCompanies = [];
      state.selectedPartnersToSync = [];
      state.partnerIntegrations = [];
    },
    setNextRedirectTo(state, data) {
      state.nextRedirectTo = data;
    },
    setPartnerIntegrationVisibility(state, partnerIntegrationVisibility) {
      state.partnerIntegrationVisibility = partnerIntegrationVisibility;
    },
    setPartnerCredentials(state, key) {
      state.partnerIntegrationCredentials = key;
    },
    setPartnerManagedCompany(state, partnerManagedCompanies) {
      state.partnerManagedCompanies = partnerManagedCompanies;
    },
    setCompanySyncSettings(state, selectedPartnersToSync) {
      state.selectedPartnersToSync = selectedPartnersToSync;
    },
    setPartnerIntegrations(state, partnerIntegrations) {
      state.partnerIntegrations = partnerIntegrations;
    },
    setSelectedPartner(state, selectedPartner) {
      state.selectedPartner = selectedPartner;
    },
    setPartner(state, partners) {
      if (!state.partnerIntegrations || !state.partnerIntegrations.result) {
        state.partners = partners;
      } else {
        state.partners = partners.map((partner) => ({
            ...partner,
          }));
      }
    },
  },
  actions: {
    async actionCheckPartner(_, data) {
      return callAPI('POST', 'checkPartner', data);
    },
    async actionGetRedirectUrlPartner(_, data) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = callAPI('POST', 'partner/getRedirectUrl', {
        ...data,
        companyId,
      });
      return res;
    },
    async actionGetPartnerIntegrations({commit}, params) {
      const res = await callAPI('POST', 'getPartnerIntegrationDetails', {
        company_id: params,
      });
      if (res && !res.error) {
        commit('setPartnerIntegrations', res);
      }
    },
    async actionGetPartnerManagedCompany({commit}, params) {
      const company = localStorage.getItem(FYGR_COMPANY);
      const partner = JSON.parse(
        localStorage.getItem('FYGR_CURRENT_SELECTED_PARTNER'),
      );
      if (!partner?.id || !partner?.partner_integration_id) {
        return;
      }
      const res = await callAPI(
        'POST',
        'getPartnerManagedCompany',
        {
          response_type: 'all',
          company_id: company,
          partner_id: partner.id,
          partner_integration_id: partner.partner_integration_id,
        },
        false,
        20,
        0,
        false,
        undefined,
        params,
      );
      if (res && !res.error) {
        commit('setPartnerManagedCompany', res?.result);
        return res?.result;
      }
      return null;
    },
    async actionSetPartnerIntegrationVisibility({commit}, param) {
      commit('setPartnerIntegrationVisibility', param);
    },
    async actionValidateCredentials({commit}, params) {
      const res = await callAPI('POST', 'partner/authenticate', params);
      if (res && !res.error) {
        commit('setPartnerCredentials', res?.result?.api_key);
      }
      return res;
    },
    async actionSyncPartnerManagedCompany({commit}, params) {
      const res = await callAPI(
        'POST',
        'syncPartnerManagedCompany',
        params,
        false,
        0,
      );
      if (res && !res?.error) {
        commit('setCompanySyncSettings', res.result);
      }
      return res;
    },
    async actionDeletePartnerIntegration(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      await callAPI('POST', 'deletePartnerIntegration', {
        company_id: companyId,
        partner_id: params.partner_id,
        partner_integration_id: params.partner_integration_id,
      });
    },
    actionSetSelectedPartner({commit}, params) {
      commit('setSelectedPartner', params);
    },
    async actionSelectPartner({commit}, params) {
      const getExistingPartner = JSON.parse(
        localStorage.getItem(FYGR_USER_SELECTED_PARTNER),
      );
      let setPartner = [];
      if (getExistingPartner) {
        if (!getExistingPartner.find((el) => el.id === params.id)) {
          setPartner = [...getExistingPartner, params];
        } else {
          setPartner = getExistingPartner;
        }
      } else {
        setPartner = [params];
      }
      localStorage.setItem(
        FYGR_USER_SELECTED_PARTNER,
        JSON.stringify(setPartner),
      );
      await commit('setSelectedPartner', params);
    },
    actionSelectCurrentPartner(_, params) {
      localStorage.setItem(
        FYGR_CURRENT_SELECTED_PARTNER,
        JSON.stringify(params),
      );
    },
    async actionGetPartners({commit}, params) {
      const token = localStorage.getItem(FYGR_ACCESS_TOKEN);
      if (token) {
        const res = await callAPI(
          'POST',
          'partners',
          {
            integration_flow: true,
            ...params,
          },
          true,
        );
        if (res && !res.error) {
          commit('setPartner', res?.result);
        }
        return res;
      }
    },
    async updateCurrentSelectedPartner(_, params) {
      const newSelectedPartner = {
        ...JSON.parse(localStorage.getItem('FYGR_CURRENT_SELECTED_PARTNER')),
        partner_integration_id: params.partner_integration_id,
      };
      localStorage.setItem(
        FYGR_CURRENT_SELECTED_PARTNER,
        JSON.stringify(newSelectedPartner),
      );
    },
  },
};
